export default class DailyAttendanceActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_DAILYATTANDANCE='GET_HELPER_DAILYATTANDANCE';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static submit(){
    return {
      type: DailyAttendanceActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type: DailyAttendanceActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: DailyAttendanceActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: DailyAttendanceActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type: DailyAttendanceActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type: DailyAttendanceActions.SHOW_DATA,
      payload: data
    };
  }
  static resetList() {
    return {
      type: DailyAttendanceActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type: DailyAttendanceActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: DailyAttendanceActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type: DailyAttendanceActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type: DailyAttendanceActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type: DailyAttendanceActions.GET_HELPER_DAILYATTANDANCE,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type: DailyAttendanceActions.ERROR_SERVER,
      payload: error
    };
  }
}